<template>
    <div style="height: 100%;" :style="{ 'background-color': $vuetify.theme.themes.light.backgroundHome }">
      <MinhaUnimed style="height: 100%;"/>
    </div>
</template>

<script>
import MinhaUnimed from '../components/MinhaUnimed/MinhaUnimed'

export default {
  components: {
    MinhaUnimed
  },
  beforeMount () {
    this.$emit('loadDados')
  }
}
</script>
